import { AxiosError } from "axios";
import useLocales from "src/hooks/useLocales";

export const useGetErrorMessage = (error: AxiosError<unknown, any> | null) => {
	let errorMessage = "";

	const { translate } = useLocales();

	if (error && error?.code !== "") errorMessage = translate("errors.DEFAULT");

	if (error && error?.code === "ERR_NETWORK") errorMessage = translate("errors.ERR_NETWORK");

	if (error && error?.code === "ERR_BAD_REQUEST")
		errorMessage = translate("errors.ERR_BAD_REQUEST");

	return { errorMessage };
};
